<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.24365"
      y="1.25"
      width="17.4095"
      height="17.5"
      rx="8.70475"
      fill="url(#paint0_radial_36_6379)"
    />
    <rect
      x="1.24365"
      y="1.25"
      width="17.4095"
      height="17.5"
      rx="8.70475"
      fill="url(#paint1_radial_36_6379)"
    />
    <rect
      x="1.24365"
      y="1.25"
      width="17.4095"
      height="17.5"
      rx="8.70475"
      fill="#4D4D4D"
    />
    <path
      d="M14.3005 6.5625C14.3005 7.08027 13.883 7.5 13.3679 7.5C12.8528 7.5 12.4352 7.08027 12.4352 6.5625C12.4352 6.04473 12.8528 5.625 13.3679 5.625C13.883 5.625 14.3005 6.04473 14.3005 6.5625Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.94815 13.125C11.6651 13.125 13.057 11.7259 13.057 10C13.057 8.27411 11.6651 6.875 9.94815 6.875C8.23118 6.875 6.83931 8.27411 6.83931 10C6.83931 11.7259 8.23118 13.125 9.94815 13.125ZM9.94815 11.875C10.9783 11.875 11.8135 11.0355 11.8135 10C11.8135 8.96447 10.9783 8.125 9.94815 8.125C8.91797 8.125 8.08284 8.96447 8.08284 10C8.08284 11.0355 8.91797 11.875 9.94815 11.875Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.73047 9.75C3.73047 7.6498 3.73047 6.5997 4.13708 5.79754C4.49475 5.09193 5.06546 4.51825 5.76742 4.15873C6.56544 3.75 7.6101 3.75 9.69944 3.75H10.1969C12.2862 3.75 13.3309 3.75 14.1289 4.15873C14.8308 4.51825 15.4015 5.09193 15.7592 5.79754C16.1658 6.5997 16.1658 7.6498 16.1658 9.75V10.25C16.1658 12.3502 16.1658 13.4003 15.7592 14.2025C15.4015 14.9081 14.8308 15.4817 14.1289 15.8413C13.3309 16.25 12.2862 16.25 10.1969 16.25H9.69944C7.6101 16.25 6.56544 16.25 5.76742 15.8413C5.06546 15.4817 4.49475 14.9081 4.13708 14.2025C3.73047 13.4003 3.73047 12.3502 3.73047 10.25V9.75ZM9.69944 5H10.1969C11.262 5 11.9861 5.00097 12.5458 5.04694C13.091 5.09171 13.3698 5.17287 13.5643 5.27248C14.0323 5.51217 14.4128 5.89462 14.6512 6.36502C14.7503 6.56052 14.831 6.84078 14.8756 7.3888C14.9213 7.95141 14.9223 8.67928 14.9223 9.75V10.25C14.9223 11.3207 14.9213 12.0486 14.8756 12.6112C14.831 13.1592 14.7503 13.4395 14.6512 13.635C14.4128 14.1054 14.0323 14.4878 13.5643 14.7275C13.3698 14.8271 13.091 14.9083 12.5458 14.9531C11.9861 14.999 11.262 15 10.1969 15H9.69944C8.63425 15 7.91015 14.999 7.35045 14.9531C6.80526 14.9083 6.52646 14.8271 6.33197 14.7275C5.864 14.4878 5.48352 14.1054 5.24508 13.635C5.14598 13.4395 5.06524 13.1592 5.0207 12.6112C4.97497 12.0486 4.974 11.3207 4.974 10.25V9.75C4.974 8.67928 4.97497 7.95141 5.0207 7.3888C5.06524 6.84078 5.14598 6.56052 5.24508 6.36502C5.48352 5.89462 5.864 5.51217 6.33197 5.27248C6.52646 5.17287 6.80526 5.09171 7.35045 5.04694C7.91015 5.00097 8.63425 5 9.69944 5Z"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial_36_6379"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7.46133 14.375) rotate(-55.5146) scale(15.9232 15.8938)"
      >
        <stop stop-color="#B13589" />
        <stop offset="0.79309" stop-color="#C62F94" />
        <stop offset="1" stop-color="#8A3AC8" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_36_6379"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.83956 19.375) rotate(-65.2494) scale(14.1085 14.0612)"
      >
        <stop stop-color="#E0E8B7" />
        <stop offset="0.444662" stop-color="#FB8A2E" />
        <stop offset="0.71474" stop-color="#E2425C" />
        <stop offset="1" stop-color="#E2425C" stop-opacity="0" />
      </radialGradient>
    </defs>
  </svg>
</template>
